var DiscountBar = class extends HTMLElement {
	connectedCallback() {
		this.shelfOutput = document.querySelector('shelf-sticky-bar');
		this.textNode = this.querySelector('.discount-bar__text');
		this.buyForNextDiscountText = this.dataset.buyForNextDiscount;
		this.youGetDiscountText = this.dataset.youGetDiscount;
		this.shelfIsFullWithoutDiscount = this.dataset.shelfIsFullWithoutDiscount;
		this.oldDiscountThreshold = 0;
		this.delay = this.getAttribute('delay') || 500;
		this.shelfOutput.addEventListener('discount-bar:update', this._onBarUpdated.bind(this));
	}

	getText(subtotalPrice, appliedDiscountPercent, nextDiscountPercent, nextDiscountThreshold) {
		if (nextDiscountPercent) {
			return this.buyForNextDiscountText
				.replace('[AMOUNT]', theme.Currency.formatMoney(nextDiscountThreshold - subtotalPrice))
				.replace('[DISCOUNT]', nextDiscountPercent);
		} else if (appliedDiscountPercent) {
			return this.youGetDiscountText.replace('[DISCOUNT]', appliedDiscountPercent);
		}
		return this.shelfIsFullWithoutDiscount;
	}
	_onBarUpdated(event) {
		const { subtotalPrice, appliedDiscount, nextDiscount } = event.detail;
		const { threshold: nextDiscountThreshold, discountPercent: nextDiscountPercent } = nextDiscount || {};
		const { discountPercent: appliedDiscountPercent } = appliedDiscount || {};
		const progress = Math.min(subtotalPrice / nextDiscountThreshold, 1);
		setTimeout(() => {
			this.textNode.innerHTML = this.getText(
				subtotalPrice,
				appliedDiscountPercent,
				nextDiscountPercent,
				nextDiscountThreshold,
			);
			this.style.setProperty('--progress', progress);
		}, this.delay);
	}
};
window.customElements.define('discount-bar', DiscountBar);
